import { Component, Input, EventEmitter, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  VoucherInitModel,
  VoucherInitVariables,
  VoucherModel,
  VoucherVariables,
} from '../../../../../models/email-template/voucher.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-voucher',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './voucher.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './voucher.component.scss'
})
export class VoucherComponent extends BaseComponent implements OnInit {
  @Input() block: VoucherModel = new VoucherInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new VoucherInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Voucher Header';
  paragraphPlaceholder: string = 'Enter Voucher Paragraph';
  textPlaceholder: string = 'Enter Voucher Text';
  linkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';
  altPlaceholder: string = 'Enter ALT Text';
  imgPlaceholder: string = 'Image';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof VoucherVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
      if (this.block.variables) {
        this.block.variables[blockName as keyof VoucherVariables] = segment;
        this.blockData.emit(this.block);
      }
      return;
    }
}
